<template>
  <div id="carData">
   
        <b-row>
          <b-col md="6">
            <h4>HSN</h4>
            <base-input
              prepend-icon="fas fa-car"
              placeholder="HSN"
              v-model="offer.hsn"
              name="HSN"
              :rules="{required: true, max:4, regex:/[a-zA-Z0-9]+/}"
            ></base-input>
          </b-col>

          <b-col md="6">
            <h4>TSN</h4>
            <base-input
              prepend-icon="fas fa-car"
              placeholder="TSN"
              v-model="offer.tsn"
              name="TSN"
              :rules="{required: true, max:3, regex:/[a-zA-Z0-9]+/}"
            ></base-input>
          </b-col>
        </b-row>



        <b-row v-if="carData.fetched">

          <b-col md="12">
            <p>
                {{ this.offer.car_brand }} {{ this.offer.car_model }} - 
                {{ this.offer.car_kw }} kw / {{ this.offer.car_ps }} PS - 
                {{ this.offer.car_haftpflicht }}/{{ this.offer.car_teilkasko }}/{{ this.offer.car_vollkasko }}
            </p>
          </b-col>
        </b-row>




        <b-row>

          <b-col md="4">
              <h4>Erstzulassung</h4>
            <base-input
              prepend-icon="fas fa-calendar"
              v-model="offer.car_first_registration"
              name="Erstzulassung"
              rules="required"
              type="date"
              placeholder="AA.MM.YYYY"
            >
            </base-input>
          </b-col>

          <b-col md="4">
              <h4>Zulassung auf den Halter</h4>
            <base-input
              prepend-icon="fas fa-calendar"
              v-model="offer.car_registration"
              name="Zulassung auf den Halter"
              rules="required"
              type="date"
              placeholder="DD.MM.YYYY"
            >
            
            </base-input>
          </b-col>

          <b-col md="4">
            <h4>Versicherungsbeginn</h4>
            <base-input
              prepend-icon="fas fa-calendar"
              v-model="offer.insurance_start"
              name="Versicherungsbeginn"
              rules="required"
              type="date"
              placeholder="DD.MM.YYYY"
            >
            </base-input>
          </b-col>

        </b-row>


        <b-row>

                  <b-col md="6">
                    <h4>Laufleistung</h4>
                      <base-input
                      prepend-icon="fas fa-car"
                      placeholder="Laufleistung"
                      v-model="offer.mileage"
                      name="Laufleistung"
                      rules="required"
                    ></base-input>
                  </b-col>


          <b-col md="6">
            <h4>Versicherungsumfang</h4>
            <base-input rules="required" name="Versicherungsumfang">
              <el-select
                v-model="offer.participation"
                filterable
                placeholder="Versicherungsumfang"
              >
                <el-option
                  v-for="option in offer.participations"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                >
                </el-option>
              </el-select>
            </base-input>
          </b-col>

        </b-row>


        <b-row v-if="false">


          <b-col md="6" v-if="this.offer.show_usage">

            <h4>
                Fahrzeugnutzung
            </h4>

            <b-form-radio-group v-model="offer.car_usage" v-if="offer.is_company">
              <div>
                <b-form-radio value="Gewerblich" name="checked" class="mb-3">
                  Gewerblich
                </b-form-radio>
                  <b-form-radio value="Privat und gewerblich" name="unchecked" class="mb-3">
                  Privat und gewerblich
                </b-form-radio>
              </div>
            </b-form-radio-group>





            <b-form-radio-group v-model="offer.car_usage" v-if="!offer.is_company">
              <div>
                <b-form-radio value="Privat" name="checked" class="mb-3">
                  Privat
                </b-form-radio>
                  <b-form-radio value="Privat und gewerblich" name="unchecked" class="mb-3">
                  Privat und gewerblich
                </b-form-radio>
              </div>
            </b-form-radio-group>






          </b-col>

          <b-col md="6" v-if="false">



            <h4>
                Fahrzeugneuwert unter 210.000 € ?
            </h4>

            <b-form-radio-group v-model="offer.new_car_above_max">
              <div>
                <b-form-radio value="false" name="checked" class="mb-3">
                  Ja
                </b-form-radio>
                  <b-form-radio value="true" name="unchecked" class="mb-3">
                  Nein
                </b-form-radio>
              </div>
            </b-form-radio-group>
          </b-col>

        </b-row>

  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import { Select, Option } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  name: "car",
  props: {
    title: "",
    icon: "",
  },
  components: {
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      loading: false,
      showUsage: false,
      showValue: false,
      below_expensive: 1,
      carData: {
          fetched: false,
          brand: '',
          ccm: '',
          haftpflicht: 0,
          kw: 0,
          model: '',
          ps: '',
          teilkasko: '',
          hsn: '',
          tsn: ''
      },
      radios: {
        radio1: "checked",
        radio2: "checked",
      },
    };
  },
  methods: {
    fetchCarData() {
        this.loading = true;
        this.$api
          .getCarData(this.offer.hsn, this.offer.tsn)
          .then((response) => {
              console.log(response);
           // this.options = [];
            /*this.options = response.data.items.map((item) => {
              return { value: item.id, label: item.city };
            });
            */
            this.carData = response.data;

            this.offer.car_brand = response.data.brand
            this.offer.car_ccm = response.data.ccm
            this.offer.car_haftpflicht = response.data.haftpflicht
            this.offer.car_kw = response.data.kw
            this.offer.car_model = response.data.model
            this.offer.car_ps = response.data.ps
            this.offer.car_teilkasko = response.data.teilkasko
            this.offer.car_vollkasko = response.data.vollkasko
            this.offer.car_hsn = response.data.hsn
            this.offer.car_tsn = response.data.tsn

            this.carData.fetched = true;
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            this.loading = false;
          });
    },
        toggleValue: function(){
            this.showValue = !this.showValue;
        },
        toggleUsage: function(){
            this.showUsage = !this.showUsage;
        },

    mayFetchCar() {
      if (
        this.offer.hsn &&
        this.offer.hsn.length == 4 &&
        this.offer.tsn &&
        this.offer.tsn.length == 3
      ) {
          this.fetchCarData();
        return true;
      }
      return false;
    },

    setDefaults(){
     // this.offer.mileage = 10000
    },

  },
  computed: {
    ...mapGetters({ currentAccount: "currentAccount" }),
    ...mapState({
      offer: (state) => state.offer,
      car_value: (state) => state.offer.car_value,
      car_usage: (state) => state.offer.car_usage,
      car_hsn: (state) => state.offer.hsn,
      car_tsn: (state) => state.offer.tsn,
      second_vehicle: (state) => state.offer.has_second_vehicle,
      only_driver: (state) => state.offer.holder_only_driver,
      dob: (state) => state.offer.dob,
      has_holder: (state) => state.offer.has_holder,
      holder_id: (state) => state.offer.holder_id,
      car_first_registration: (state) => state.offer.car_first_registration,
      mileage: (state) => state.offer.mileage,
      insurance_start: (state) => state.offer.insurance_start,
      participation: (state) => state.offer.participation,
      paymentterm: (state) => state.offer.paymentterm,
      radio_usage: (state) => state.offer.radio_usage,
    }),
  },
watch: {
    car_hsn(newValue, oldValue) {
      console.log(`Updating from ${oldValue} to ${newValue}`);
      this.mayFetchCar();
    },
    car_tsn(newValue, oldValue) {
      console.log(`Updating from ${oldValue} to ${newValue}`);
      this.mayFetchCar();
    },

    participation(newValue, oldValue) {
      console.log(`Updating participation from ${oldValue} to ${newValue}`);
     // this.toggleValue();
    },

    car_first_registration(newValue, oldValue) {
      console.log(`Updating DATE from ${oldValue} to ${newValue}`);
     // this.toggleValue();
    },

    car_value(newValue, oldValue) {
      console.log(`Updating from ${oldValue} to ${newValue}`);
      this.toggleValue();
    },
    radio_usage(newValue, oldValue) {
      this.offer.selected_usage_only_private = true;

    },

    car_usage(newValue, oldValue) {
      
      console.log(`Updating from ${oldValue} to ${newValue}`);
    
      this.toggleUsage();
      // Do whatever makes sense now
      if (newValue === 'success') {
        this.complex = {
          deep: 'some deep object',
        };
      }
    },
},
  mounted() {
    this.setDefaults();
  },
};
</script>
<style>
</style>